<template>
  <div class="cart">
    <div class="cart-img">
      <div class="img">
        <img src="../../assets/pc/images/home/cart.png" alt="" />
      </div>
      <div class="step">
        <StepNumber align="right" :current="0" chooseType="confirm">
          <StepCommit :index="1">1.我的购物车</StepCommit>
          <StepCommit :index="2">2.填写核对订单信息</StepCommit>
          <StepCommit :index="3">3.成功提交订单</StepCommit>
        </StepNumber>
      </div>
    </div>
    <div class="cart-body">
      <div class="title">
        <div class="title-select">
          <label for="label" class="well-check">
            <input
              type="checkbox"
              @click="selectAll"
              v-model="checkAll"
              id="label"
            />
            <span>全选</span>
          </label>
        </div>
      </div>
      <div class="product">商品信息</div>
      <div class="package">套餐</div>
      <div class="num">数量</div>
      <div class="price">价格</div>
    </div>
    <div class="cart-detail">
      <div class="item" v-for="(item, index) of shoppingCart" :key="item.id">
        <label for="label" class="well-check">
          <input
            type="checkbox"
            @click="chooseIndex(item.id)"
            v-model="item.checked"
            id="label"
          />
        </label>
        <div class="item-img">
          <img :src="item.productInfo.image" alt="" />
        </div>
        <div class="item-name">
          {{ item.productInfo.store_name }}
        </div>
        <div
          class="item-package"
          v-if="
            item.productInfo.attrInfo &&
              Object.keys(item.productInfo.attrInfo).length > 0 &&
              item.productInfo.attrInfo.hasOwnProperty('suk')
          "
        >
          {{ item.productInfo.attrInfo.suk }}
        </div>
        <div class="item-package" v-else></div>
        <div class="item-num">
          <div
            class="del"
            :class="item.cart_num === 1 ? 'active' : ''"
            @click.prevent="delNum(index)"
          >
            <Icon type="android-remove"></Icon>
          </div>
          <div class="item-num--input">
            <input
              type="text"
              v-model="item.cart_num"
              @input.prevent="specifiName(index)"
              @blur.prevent="blurName(index)"
            />
          </div>
          <div class="add" @click.prevent="addNum(index)">
            <Icon type="android-add"></Icon>
          </div>
        </div>
        <div class="item-price">{{ item.truePrice }}</div>
      </div>
      <div class="no-data" v-if="shoppingCart.length === 0">
        你的购物车还是空的，
        <router-link tag="span" to="/goodsList">去购物></router-link>
      </div>
    </div>
    <div class="footer">
      <div class="footer-del">
        <span class="footer-del--all" @click="delCart">删除已选商品</span>
      </div>
      <div class="footer-order">
        <div class="footer-order--total">
          <span>合计:</span>
          <span class="red-color"
            >￥<span class="price">{{ totalMoney }}</span></span
          >
        </div>
        <div class="footer-order--commit" @click="placeOrder">
          去付款
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StepNumber from "@/components/pc/commonTool/Steps/StepNumber";
import StepCommit from "@/components/pc/commonTool/Steps/StepCommit";
import { getCartList } from "@api/user";
import { changeCartNum, postCartDel } from "@api/store";
import { mul, add } from "@utils/bc";
import { mapActions } from "vuex";
export default {
  name: "ShoppingCart",
  components: {
    StepNumber,
    StepCommit
  },
  data() {
    return {
      shoppingCart: [],
      checkedIds: [],
      checkAll: false,
      totalMoney: 0,
      changeIndex: 0 // 更改商品的索引值
    };
  },
  created() {
    this.getCartInfo();
  },
  methods: {
    ...mapActions(["CHANGE_SHOPPING_CART"]),
    getCartInfo() {
      getCartList().then(res => {
        const cartList = res.data.valid;
        this.$set(this, "shoppingCart", cartList);
        this.CHANGE_SHOPPING_CART(cartList);
      });
    },
    selectAll() {
      this.checkAll = !this.checkAll;
      this.checkedIds = [];
      if (this.checkAll) {
        this.shoppingCart.forEach(item => {
          item.checked = true;
          this.checkedIds.push(item.id);
        });
      } else {
        this.shoppingCart.forEach(item => {
          item.checked = false;
        });
      }
      this.countMoney(); // 重新计算总额
    },
    chooseIndex(id) {
      const i = this.checkedIds.indexOf(id);
      if (i !== -1) {
        this.checkedIds.splice(i, 1);
        this.shoppingCart.forEach(item => {
          if (item.id === id) {
            item.checked = false;
          }
        });
      } else {
        this.checkedIds.push(id);
        this.shoppingCart.forEach(item => {
          if (item.id === id) {
            item.checked = true;
          }
        });
      }

      // 判断是否全部选中
      if (this.checkedIds.length === this.shoppingCart.length) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }

      this.countMoney(); // 重新计算总额
    },
    chooseDel() {},
    // 总共价钱；
    countMoney() {
      let carMoney = 0;
      this.shoppingCart.forEach(item => {
        if (item.checked) {
          carMoney = add(carMoney, mul(item.cart_num, item.truePrice));
        }
      });
      this.totalMoney = carMoney;
    },
    // 数量输入事件监听
    specifiName(index) {
      this.changeIndex = index;
      const number = this.shoppingCart[index].cart_num;
      if (number < 1) {
        return this.$Message.error("您的输入有误");
      }
    },
    // 输入框失去焦点时
    blurName(index) {
      const id = this.shoppingCart[index].id;
      const number = this.shoppingCart[index].cart_num;
      if (!/^\d+$/.test(number)) {
        return this.$Message.error("请输入整数");
      }
      changeCartNum(id, number).then(() => {
        this.changeNum();
        this.countMoney();
      });
    },
    // 购物车数量更改时，只需更改购物车的数量即可
    changeNum() {
      getCartList().then(res => {
        const cartList = res.data.valid;
        this.shoppingCart[this.changeIndex].cart_num =
          cartList[this.changeIndex].cart_num;
        this.$set(this, "shoppingCart", this.shoppingCart);
      });
    },
    delNum(index) {
      let list = this.shoppingCart[index];
      if (list.cart_num === 1) return;
      list.cart_num--;
      this.$set(this.shoppingCart[index], "cart_num", list.cart_num);
      this.changeDelAdd(index);
    },
    addNum(index) {
      let list = this.shoppingCart[index];
      list.cart_num++;
      this.$set(this.shoppingCart[index], "cart_num", list.cart_num);
      this.changeDelAdd(index);
    },
    // 减少和增加功能时
    async changeDelAdd(index) {
      const id = this.shoppingCart[index].id;
      const number = this.shoppingCart[index].cart_num;
      await changeCartNum(id, number);
      getCartList().then(res => {
        const cartList = res.data.valid;
        this.shoppingCart[index].cart_num = cartList[index].cart_num;
        this.$set(this, "shoppingCart", this.shoppingCart);
        this.changeNum();
        this.countMoney();
      });
    },
    placeOrder() {
      if (this.checkedIds.length === 0) {
        this.$Message.error("您未选中商品");
        return;
      }
      this.$router.push("/order/" + this.checkedIds.join(","));
    },
    delCart() {
      postCartDel(this.checkedIds).then(() => {
        this.$Message.success("删除商品成功");
        this.getCartInfo();
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.cart
  margin 50px auto 15px
  width 88%
  min-height 500px
  .cart-img
    display flex
    justify-content space-between
    .img
      width 140px
      height 40px
      img
        width 100%
        height 100%
  .cart-body
    font-size 14px
    color #666
    margin-top 32px
    display flex
    background #fff
    padding 15px 30px
    border 1px solid #e1e1e1
    color #666
    .title
      .title-select
        .well-check
          cursor pointer
          span
            margin-left 10px
            margin-right 10px
            font-size 14px
    .product
      margin-left 95px
      width 520px
    .package
      width 100px
      text-align center
    .num
      width 100px
      margin-left 50px
      text-align center
    .price
      width 100px
      margin-left 20px
      text-align center
  .cart-detail
    margin-top 20px
    padding 10px 30px
    background #fff
    border 1px solid #e1e1e1
    .item
      display flex
      align-items center
      padding 10px 0
      border-bottom 1px dashed #ccc
      &:last-child
        border-bottom 0
      .item-img
        width 70px
        height 70px
        margin-left 34px
        img
          width 100%
          height 100%
      .item-name
        margin-left 40px
        width 520px
        font-size 14px
      .item-package
        width 100px
        text-align center
        font-size 14px
      .item-num
        width 100px
        margin-left 50px
        display flex
        justify-content space-between
        border 1px solid #ccc
        text-align center
        border-radius 2px
        .del,
        .add
          width 25px
          line-height 30px
          font-size 20px
          cursor pointer
        .del
          &.active
            &:hover
              font-size 0
              background #e7e5e5
              position relative
              &:before
                content ''
                display table
                position absolute
                width 2px
                height 20px
                background #fff
                transform rotate(-45deg)
                top 5px
                left 12px
              &:after
                content ''
                display table
                position absolute
                width 15px
                height 15px
                border 2px solid #fff
                top 8px
                left 5px
                border-radius 50%
        &--input
          flex 1
          margin 3px 0
          border-left 1px solid #ccc
          border-right 1px solid #ccc
          input
           width 100%
           line-height 24px
           text-align center
           font-size 14px
      .item-price
        width 100px
        text-align center
        margin-left 20px
        font-size 14px

    .no-data
      height 200px
      line-height 200px
      text-align center
      font-size 14px
      color #c3c3c3
      font-family 'Microsoft yahei'
      span
        color #ff5c4d
        cursor pointer
  .footer
    margin-top 30px
    padding-left 30px
    height 80px
    background #fff
    border 1px solid #e1e1e1
    display flex
    justify-content space-between
    align-items center
    .footer-del
      &--all
        margin-left 5px
        color #999
        border 1px solid #999
        padding 5px 10px
        border-radius 15px
        cursor pointer
        &:hover
          color red
          border-color red
    .footer-order
      display flex
      &--total
        width 200px
        line-height 80px
        display flex
        >span
          font-size 14px
          font-weight 700
          color #666
          &.red-color
            transform translateY(2px)
            color #ff4040
            margin-left 20px
            .price
              font-size 30px
              line-height 0
      &--commit
        width 200px
        font-size 26px
        text-align center
        line-height 80px
        background #fe6765
        color #fff
        cursor pointer

.well-check
  input
    cursor pointer
    width 14px
    height 14px
    border 1px solid #ccc
    border-radius 2px
    &:checked
      background #2d8cf0
      border-color #2d8cf0
      position relative
      &:after
        content ''
        display table
        width 4px
        height 8px
        position absolute
        border 2px solid #fff
        border-top 0
        border-left 0
        transform rotate(45deg)
        top 1px
        left 4px
</style>
